import { useCallback } from "react";
import { useDispatch } from "react-redux";

import { analyticsLogClickSidebarRow } from "seneca-common/features/session/analytics";
import useCallbackWithAnalytics from "seneca-common/utils/hooks/analytics/useCallbackWithAnalytics";

import { closeSidebar } from "features/classroom/state";
import { sidebarWillOverlayClassroomWhenOpen } from "features/common/components/sidebar/utils";

export default function useSectionRowClickWithAnalytics(
  sectionId: string,
  courseId: string,
  target: string
) {
  const dispatch = useDispatch();

  const onWrongAnswersSectionClick = useCallback(() => {
    if (sidebarWillOverlayClassroomWhenOpen()) dispatch(closeSidebar());
  }, [dispatch]);

  const handleWrongAnswersSectionClickAnalytics = useCallback(
    () =>
      analyticsLogClickSidebarRow({
        courseId,
        sectionId,
        target
      }),
    [courseId, sectionId, target]
  );

  const handleWrongAnswersSectionClick = useCallbackWithAnalytics(
    onWrongAnswersSectionClick,
    handleWrongAnswersSectionClickAnalytics
  );

  return handleWrongAnswersSectionClick;
}
